import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  .app {
    max-width: 1200px;
    margin: 0 auto;
  }
`;

const Region = styled.div`
  text-align: center;
      font-size: 2.5em;
    font-weight: bold;
    text-align: center;
    margin: 60px 0px 0px;
`;

const BigNumbers = styled.div`
      display: flex;
    justify-content: space-evenly;
    margin: 40px auto;
    padding: 0px 20px;
    text-align: center;
  
  .bignumber {
    background-color: rgb(12, 236, 145);
    border-radius: 1000px;
    min-width: 280px;
    padding: 22px;
    font-size: 2.5em;
    font-weight: bold;
  }
  
  .subtext {
    text-transform: uppercase;
    font-size: 1.3em;
    margin-top: 20px;
    font-weight: bold;
  }
`;

const Prompt = styled.div`
      font-size: 1.1em;
    margin: 0px auto;
    display: flex
;
    justify-content: center;
    align-items: center;
    max-width: 1000px;
    justify-content: space-evenly;
    padding: 0px 15px;
    text-align: center;
  
  a, .share {
    text-decoration: underline;
    cursor: pointer;
    text-underline-offset: 0.3em;
    color: unset;
}
`;

const Footer = styled.div`
  margin-top: 80px;
    background-color: #14343e;
    color: white;
    display: flex
;
    justify-content: space-between;
    align-items: center;
    padding: 50px;
    font-size: 1.2em;
  
  a {
    color: #fff;
    text-decoration: none;
  }
  
  img {
    height: 24px;
    margin-left: 10px;
  }
`;

const Layout = ({ children, region, stats, processedData }) => {
  console.log('Layout rendered with region:', region);
  // Split the region by '>' to determine the navigation level
  const levels = region.split(' > ');
  
  // Only show back navigation if we're not on the home page
  const showBackNav = region !== "Nederland";
  
  // Get display names from the data structure
  const getDisplayName = (level, index) => {
    if (level === "Nederland" || !processedData) return level;
    
    try {
      if (index === 0) { // provincie
        return processedData[level.toLowerCase()]?.displayName || level;
      }
      if (index === 1) { // gemeente
        return processedData[levels[0].toLowerCase()]?.gemeentes[level.toLowerCase()]?.displayName || level;
      }
      if (index === 2) { // school
        return processedData[levels[0].toLowerCase()]?.gemeentes[levels[1].toLowerCase()]?.schools[level.toLowerCase()]?.displayName || level;
      }
    } catch (e) {
      return level;
    }
    return level;
  };

  // Get the current level name with proper formatting
  const currentLevel = getDisplayName(levels[levels.length - 1], levels.length - 1);
  
  // Build the breadcrumb links
  const getBackLink = () => {
    if (levels.length === 1) return '/'; // From provincie back to national
    
    // Get the actual keys from processedData instead of formatting the display names
    if (levels.length === 2) {
      const provincieKey = Object.keys(processedData).find(key => 
        processedData[key].displayName === levels[0]
      );
      return `/${provincieKey || levels[0].toLowerCase()}`;
    }
    
    if (levels.length === 3) {
      const provincieKey = Object.keys(processedData).find(key => 
        processedData[key].displayName === levels[0]
      );
      const gemeenteKey = Object.keys(processedData[provincieKey]?.gemeentes || {}).find(key =>
        processedData[provincieKey].gemeentes[key].displayName === levels[1]
      );
      return `/${provincieKey || levels[0].toLowerCase()}/${gemeenteKey || levels[1].toLowerCase()}`;
    }
    
    return '/';
  };

  const getBackText = () => {
    if (levels.length === 1) return 'Terug naar Nederland';
    if (levels.length === 2) return `Terug naar ${getDisplayName(levels[0], 0)}`;
    if (levels.length === 3) return `Terug naar ${getDisplayName(levels[1], 1)}`;
    return 'Terug naar Nederland';
  };

  return (
    <div>
      <Link to="/">
        <picture>
          <source media="(min-width: 650px)" srcSet="/header.png" />
          <source media="(min-width: 200px)" srcSet="/header_mobile.png" /> 
          <img src="/header.png" alt="header" style={{ width: '100%' }} />
        </picture>
      </Link>
      <div className="app">


        {showBackNav && (
          <div className="region_small">
            <Link to={getBackLink()}>← {getBackText()}</Link>
          </div>
        )}

        <div className="region">{currentLevel}</div>

        {stats && (
          <div className="bignumbers">
            <div>
              <div className="bignumber">{stats.children}</div>
              <div className="subtext">Kinderen</div>
            </div>
            <div>
              <div className="bignumber">{stats.schools}</div>
              <div className="subtext">Scholen</div>
            </div>
          </div>
        )}

        <div className="prompt">
          <a href="https://ouderpact.smartphonevrijopgroeien.nl/">Teken het Ouderpact ✍️</a>
          <span 
            className="share" 
            onClick={() => {
              if (navigator.share) {
                navigator.share({
                  title: 'Teken het Ouderpact',
                  text: 'Sluit je je aan bij een groeiende groep ouders in Nederland die kiest om te wachten met het geven van een smartphone aan hun kind',
                  url: 'https://ouderpact.smartphonevrijopgroeien.nl/'
                }).catch(console.error);
              }
            }}
          >
            Deel het Ouderpact 🔗
          </span>
        </div>

        {children}


      </div>
      <div className="footer">
        <div>
          <a href="https://smartphonevrijopgroeien.nl">smartphonevrijopgroeien.nl</a>
        </div>
        <div>
          <a href="https://whatsapp.smartphonevrijopgroeien.nl/">
            <img src="/whatsapp.svg" alt="whatsapp" />
          </a>
          <a href="https://www.instagram.com/smartphonevrijopgroeien/">
            <img src="/instagram.svg" alt="instagram" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Layout;